export const ERROR_CLUSTER_RUN_ID_KEY = "errorClusterRunId";
export const ERROR_CLUSTER_GROUP_ID_KEY = "errorClusterGroupId";
